/**
 *
 * Header
 *
 */

import React from "react"

import AdminMandu from "./skeleton/admin-mandu"
import Admin from "./skeleton/admin"
import Ambassador from "./skeleton/ambassador"
import Leader from "./skeleton/leader"
// import coolboxLogo from '../../images/coolbox_logo.png';
import "./index.less"
import { ROLE_MANDU_ADMIN, ROLE_MANDU_SUPER_ADMIN } from "../../utils/constants"
import { LOCAL_ACTIVE_ROL } from "../../utils/storage"

const id_role_adm_mandu = [
  ROLE_MANDU_SUPER_ADMIN.toString(),
  ROLE_MANDU_ADMIN.toString(),
]

class Header extends React.Component {
  validateAdminManduRole = () => {
    const id_role = LOCAL_ACTIVE_ROL()
    const route = `${window.location.origin}/`
    return id_role_adm_mandu.includes(id_role) && process.env.ADMIN_URL == route
  }

  render() {
    let id_role = parseInt(LOCAL_ACTIVE_ROL())
    if (this.validateAdminManduRole()) {
      id_role = 0
    }
    switch (id_role) {
      case 0: // super admin mandu||3-4
        return <AdminMandu />
      case 1: // is super admin gestor
      case 2: // is admin gestor
        return <Admin />
      case 5: // is ambassador
        return <Ambassador />
      case 6: // is ambassador
        return <Leader />
      default:
        return <Admin />
    }
  }
}

Header.propTypes = {}

export default Header
